import { render, staticRenderFns } from "./SetEquivalences.vue?vue&type=template&id=e444c890&scoped=true&"
import script from "./SetEquivalences.vue?vue&type=script&lang=js&"
export * from "./SetEquivalences.vue?vue&type=script&lang=js&"
import style0 from "./SetEquivalences.vue?vue&type=style&index=0&id=e444c890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e444c890",
  null
  
)

export default component.exports